import React, { forwardRef, useEffect, useImperativeHandle, useState } from 'react';
import Api from '../../_helpers/Api';
import docIcon from '../../assets/img/icons/document.png';
import closeIcon from '../../assets/img/icons/close.png';
import loader from '../../assets/img/loader.svg';
import { trans } from '../../_providers/Translation';
import moment from 'moment';

function InvoiceAttributes(props, ref) {

    const [state, setState] = useState({
        data: null,
        overlay: false,
        modal: false,
        loading: false,
        onSuccess: null,
    });

    const [validations, setValidations] = useState(null);

    useImperativeHandle(ref, () => ({
        open: data => {
            handleOpen(data)
        },
        close: () => {
            handleClose()
        },
        onSuccess: fn => {
            setState(prev => ({
                ...prev,
                onSuccess: fn
            }))
        }
    }));

    const handleOpen = (data) => {

        setState(prev => ({
            ...prev,
            data: data,
            overlay: true,
        }))

        setTimeout(() => {
            setState(prev => ({
                ...prev,
                modal: true,
            }))
        }, 50)

    }

    const handleClose = e => {
        if (e) e.preventDefault()

        setState(prev => ({
            ...prev,
            id: null,
            modal: false,
        }))

        setTimeout(() => {
            setState(prev => ({
                ...prev,
                overlay: false,
            }))
        }, 50)

        if (typeof props.onClose === 'function') {
            props.onClose();
        }
    }

    const handleSave = e => {
        e.preventDefault();

        setState(prev => ({
            ...prev,
            loading: true,
        }));

        setValidations(null);

        let data = new FormData(e.target);

        data.append('id', state.data.id);

        Api.post('invoices/update', data)
            .then(res => {
                if (res.data) {
                    handleClose();

                    if (typeof state.onSuccess === 'function') {
                        state.onSuccess();
                    }
                }
            })
            .catch(error => {

                setState(prev => ({
                    ...prev,
                    loading: false,
                }));

                let _err = error.response;

                if (_err && _err.status && _err.status == 422) {
                    for (let [input, err] of Object.entries(_err.data.errors)) {

                        setValidations(prevState => {
                            return { ...prevState, [input]: true }
                        });
                    }
                }

            });
    }

    const handleInputChange = (e, onlyDigits = false) => {
        let name = e.target.name;
        let val = e.target.value;

        if (onlyDigits) {
            val = val.replace(/[^0-9]/g, '');
        }

        setState(prev => ({
            ...prev,
            data: {
                ...prev.data,
                [name]: val
            }
        }));
    }

    const handleDateChage = e => {
        let name = e.target.name + '_ymd';
        let val = e.target.value;

        setState(prev => ({
            ...prev,
            data: {
                ...prev.data,
                [name]: val
            }
        }));
    }

    return (
        <div className={`${state.overlay ? 'visible' : ''} overlay`} onSubmit={handleSave}>

            <form className={`${state.modal ? 'show' : ''} popup-primary small`}>

                <h2 className="head">
                    <img src={docIcon} alt="document" className="document-icon" />
                    {trans('headings.editInvoice')}

                    <img src={closeIcon} alt="close" className="close-icon" onClick={handleClose} />
                </h2>

                <div className="popup-container">
                    <div className="col">
                        <label>
                            {trans('labels.date')}
                        </label>

                        <input
                            type="date"
                            name="date"
                            max={moment().format('YYYY-MM-DD')}
                            value={state.data?.date_ymd || ''}
                            className={validations && validations.date ? 'validate' : ''}
                            onChange={handleDateChage}
                        />
                    </div>
                </div>

                <br />

                <div className="popup-container">
                    <div className="col">
                        <label>
                            {trans('labels.number')}
                        </label>

                        <input
                            type="text"
                            name="no"
                            value={state.data?.no || ''}
                            className={validations && validations.no ? 'validate' : ''}
                            onChange={e => handleInputChange(e, true)}
                        />
                    </div>
                </div>


                <div className="footer align-center">
                    {state.loading ?
                        <img src={loader} alt="loading" />
                        :
                        <>
                            <button className="button" onClick={handleClose}>
                                {trans('buttons.cancel')}
                            </button>
                            <button className="button button-primary" type="submit">
                                {trans('buttons.save')}
                            </button>
                        </>
                    }
                </div>
            </form>
        </div>
    )
}

export default forwardRef(InvoiceAttributes);